import { render } from "./TopHero.vue?vue&type=template&id=2b08934c"
import script from "./TopHero.vue?vue&type=script&lang=js"
export * from "./TopHero.vue?vue&type=script&lang=js"

import exportComponent from "/Users/unipar/Code/neo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__